module.exports = __webpack_public_path__ + "static/media/edhilson.2f9a490d.jpg";